module.exports = {
  apiurl: "https://tt.console.idleguildmaster.info/api",

  // 웹사이트 버전. DB gm_settings.app_version과 다르면 자동 새로고침.
  // 강제 새로고침이 필요한 배포마다 이 값과 DB 값을 동일하게 올릴 것.
  appVersion: "1.0.0",

  trans: {
    "class": { "kor": "클래스", "eng": "Class" },
    "cant_sold": { "kor": "판매불가", "eng": "Can't be sold" },
    "combine_off": { "kor": "조합식 끄기", "eng": "Off Combine" },
    "combine_on": { "kor": "조합식 보기", "eng": "On Combine" },
    "monster": { "kor": "몬스터", "eng": "Monster" },
    "item": { "kor": "아이템", "eng": "Item" },
    "item_select": { "kor": "아이템 선택", "eng": "Item select" },
    "item_search": { "kor": "아이템 검색", "eng": "Item search" },
    "item_search2": { "kor": "아이템명", "eng": "Item name" },
    "item_important_off": { "kor": "아이템 중요도 설명 접기", "eng": "Off Item importance description" },
    "item_important_on": { "kor": "아이템 중요도 설명 보기", "eng": "On Item importance description" },
    "item_important_1": { "kor": "지나가는 정도로 필요한 수준", "eng": "Levels necessary for passing through" },
    "item_important_2": { "kor": "맵 진행에 어느정도 필요한 수준", "eng": "Levels necessary for progressing through the map" },
    "item_important_3": { "kor": "있으면 진행이 편해지는 수준", "eng": "Levels that make progress easier if you have them" },
    "item_important_4": { "kor": "특수한 상황에서 꼭 필요한 수준", "eng": "Levels absolutely necessary in special situations" },
    "item_important_5": { "kor": "지구가 반쪽이 나도 만들어야 하는 수준", "eng": "Levels that must be made even if the Earth is split in half" },
    "sort_eff_on": { "kor": "가격효율 순으로 보기", "eng": "Sort by efficiency" },
    "sort_general": { "kor": "일반 순으로 보기", "eng": "Sort by normal" },
    "logout": { "kor": "로그아웃", "eng": "Logout" },
    "login": { "kor": "로그인", "eng": "Login" },
    "back": { "kor": "뒤로가기", "eng": "Back" },
    "combine_sick": { "kor": "조합 식", "eng": "Combines" },
    "search": { "kor": "검색", "eng": "search" },
    "recipe": { "kor": "제작법", "eng": "Recipe" },
    "next_item": { "kor": "상위 아이템", "eng": "Next Item" },
    "ea": { "kor": "개수", "eng": "ea" },
    "order_change": { "kor": "순서변경", "eng": "order change" },
    "control": { "kor": "제어", "eng": "control" },
    "drop_rate_p": { "kor": "드롭률(%)", "eng": "Drop rate(%)" },
    "drop_item": { "kor": "드롭 아이템", "eng": "Drop Item" },
    "drop_monster": { "kor": "드롭 몬스터", "eng": "Drop Monster" },
    "search_placeholder": { "kor": "검색어를 입력하세요.", "eng": "Enter search term" },
    "prev": { "kor": "이전", "eng": "Prev" },
    "next": { "kor": "다음", "eng": "Next" },
    "prev_super": { "kor": "맨앞", "eng": "First" },
    "next_super": { "kor": "맨뒤", "eng": "Last" },
    "trait": { "kor": "특성", "eng": "Trait" },
    "trait_comment": { "kor": "특성 코멘트", "eng": "Trait Comment" },
    "exp_table": { "kor": "경험치 표", "eng": "Exp Table" },
    "open_all": { "kor": "전부 열기", "eng": "Open All" },
    "close_all": { "kor": "전부 닫기", "eng": "Close All" },
    "open_cal": { "kor": "계산기 열기", "eng": "Open Calculator" },
    "close_cal": { "kor": "계산기 접기", "eng": "Close Calculator" },
    "cal_explain": { "kor": "※모험가의 현재 정보를 설정하고 [계산하기]를 누르면 결과가 나타납니다.", "eng": "※Set the adventurer's current information and click [Calculate] to see the results." },
    "cal_explain2": { "kor": "티어 및 목표 티어를 누르면 승천 여부를 전환할 수 있습니다.", "eng": "You can toggle whether to ascend or not by tapping on the Tier and Target Tier." },
    "tier": { "kor": "티어", "eng": "Tier" },
    "level": { "kor": "레벨", "eng": "Level" },
    "current_tier": { "kor": "현재 티어", "eng": "Current Tier" },
    "current_exp": { "kor": "현재 경험치", "eng": "Current EXP" },
    "exp_per_hour": { "kor": "획득 경험치/h", "eng": "EXP per hour" },
    "exp_per_hour2": { "kor": "시간당 획득 경험치", "eng": "EXP per hour" },
    "target_tier": { "kor": "목표 티어", "eng": "Target Tier" },
    "target_level": { "kor": "목표 레벨", "eng": "Target Level" },
    "calculate": { "kor": "계산하기", "eng": "Calculate" },
    "calculating": { "kor": "계산중...", "eng": "Calculating..." },
    "need_exp": { "kor": "필요 경험치", "eng": "Need EXP" },
    "need_time": { "kor": "필요 시간", "eng": "Need Time" },
    "expected_date_time": { "kor": "예상 일시", "eng": "Expected DateTime" },
    "reached_exp": { "kor": "도달 경험치", "eng": "Reached EXP" },
    "cumulative_exp": { "kor": "누적 경험치", "eng": "Cumulative EXP" },
    "exp": { "kor": "경험치", "eng": "EXP" },
    "pet_exp_table_explain": { "kor": "※레벨을 직접 입력하거나 레벨 셀을 클릭해서 넣을 수 있습니다.", "eng": "※You can enter the level directly or click on the level cell to enter it." },
    "pet_merge_explain": { "kor": "※먹일 펫에 투자된 총 경험치의 80%가 대상 펫에 합성됩니다.", "eng": "※80% of the total EXP invested in the pet to be fed will be synthesized into the target pet." },
    "target_pet": { "kor": "대상 펫", "eng": "Target Pet" },
    "merging_pet": { "kor": "먹일 펫", "eng": "Merging Pet" },
    "result": { "kor": "결과", "eng": "Result" },
    "mana_gain": { "kor": "마나 회복량", "eng": "Mana gain" },
    "skill_turn": { "kor": "스킬 사용까지 필요 턴", "eng": "Turns required to use skill" },
    "report_suggest": { "kor": "제보&건의", "eng": "Report&Suggest" },
    "view_my": { "kor": "내 글만 보기", "eng": "View my posts" },
    "view_all": { "kor": "전체 보기", "eng": "View All posts" },
    "all": { "kor": "전체", "eng": "All" },
    "write": { "kor": "글쓰기", "eng": "Write" },
    "open_reply": { "kor": "답변 보기", "eng": "Open reply" },
    "close_reply": { "kor": "답변 접기", "eng": "Close reply" },
    "writer": { "kor": "작성자", "eng": "Writer" },
    "writer_noname_explain": { "kor": "※미입력 시 [익명]으로 들어갑니다.", "eng": "※If not entered, it will be entered as [Noname]." },
    "secret_explain": { "kor": "※체크 시 로그인한 작성자 또는 관리자만 볼수 있습니다.", "eng": "※When checked, only logged-in writer or administrators can view it." },
    "title": { "kor": "제목", "eng": "Title" },
    "category": { "kor": "카테고리", "eng": "Category" },
    "content": { "kor": "내용", "eng": "Content" },
    "submit": { "kor": "등록", "eng": "Submit" },
    "submitting": { "kor": "등록중...", "eng": "Submitting..." },
    "update": { "kor": "수정", "eng": "Update" },
    "team_sharing": { "kor": "조합 공유", "eng": "Team Sharing" },
    "view_my_team": { "kor": "내 조합만 보기", "eng": "View my teams" },
    "view_my_up": { "kor": "하트 표시 보기", "eng": "View my Ups" },
    "share_team": { "kor": "조합 공유하기", "eng": "Share team" },
    "login_explain": { "kor": "로그인 정보를 입력해주세요.", "eng": "Please enter login infos." },
    "simple_join": { "kor": "초간단 회원가입", "eng": "Super simple join" },
    "join_explain": { "kor": "회원가입 정보를 입력해주세요.", "eng": "Please enter join infos." },
    "bad_nickname_explain": { "kor": "※부적절한 닉네임은 제재될 수 있습니다.", "eng": "※Inappropriate nicknames may be subject to sanctions." },
    "id": { "kor": "아이디", "eng": "ID" },
    "nickname": { "kor": "닉네임", "eng": "Nickname" },
    "password": { "kor": "비밀번호", "eng": "Password" },
    "join": { "kor": "가입하기", "eng": "Join" },
    "map": { "kor": "맵", "eng": "Map" },
    "pet": { "kor": "펫", "eng": "Pet" },
    "pet_level": { "kor": "펫 레벨", "eng": "Pet Level" },
    "pet_trait": { "kor": "펫 특성", "eng": "Pet Trait" },
    "pet_select": { "kor": "펫 선택", "eng": "Select Pet" },
    "trait_select1": { "kor": "특성1 선택", "eng": "Select Trait1" },
    "trait_select2": { "kor": "특성2 선택", "eng": "Select Trait2" },
    "trait_select3": { "kor": "특성3 선택", "eng": "Select Trait3" },
    "trait_select4": { "kor": "특성4 선택", "eng": "Select Trait4" },
    "memo": { "kor": "비고", "eng": "Memo" },
    "use_version": { "kor": "사용 버전", "eng": "Use Version" },
    "memo_explain": { "kor": "※모험가 포션 정보, 전복 정도 등 자유롭게 작성", "eng": "※Freely write information about adventurer potions, degree of wipe, etc." },
    "use_version_explain": { "kor": "※최신버전이 기본값으로 들어갑니다.", "eng": "※The latest version is set as default." },
    "adventurer": { "kor": "모험가", "eng": "Adventurer" },
    "adventurer_search_explain": { "kor": "사용법: 모험가(또는 티어), 아이템을 검색하고 빈칸을 클릭하면 적용됩니다.\n다시 누르면 지워집니다.", "eng": "Usage: Search for an adventurer (or tier), an item, and click on a blank space to apply.\nClick again to clear." },
    "adventurer_search_placeholder": { "kor": "티어 숫자 또는 모험가명 검색", "eng": "Search by tier number or adventurer name" },
    "adventurer_search_placeholder2": { "kor": "티어 숫자 또는 모험가명", "eng": "tier or name" },
    "adventurer_select": { "kor": "모험가 선택", "eng": "Select adventurer" },
    "order": { "kor": "순서", "eng": "Order" },
    "wearing_items": { "kor": "착용 아이템", "eng": "Wearing Items" },
    "reset": { "kor": "초기화", "eng": "Reset" },
    "notice": { "kor": "개선내역", "eng": "Notice" },
    "release": { "kor": "패치노트", "eng": "Release" },
    "regist": { "kor": "등록", "eng": "Regist" },
    "registing": { "kor": "등록중...", "eng": "Registing..." },
    "new_regist": { "kor": "신규등록", "eng": "New Regist" },
    "edit": { "kor": "수정", "eng": "Edit" },
    "list": { "kor": "목록", "eng": "List" },
    "delete": { "kor": "삭제", "eng": "Delete" },
    "map_explain": { "kor": "※맵 변경 시 작성 중이던 모험가 목록이 초기화됩니다.", "eng": "※If you change the map, the adventurer information you were writing will be reset." },
    "view": { "kor": "조회", "eng": "View" },
    "comment_view": { "kor": "코멘트 보기", "eng": "View comment" },
    "comment_hide": { "kor": "코멘트 숨기기", "eng": "Hide comment" },
    "comment_submit": { "kor": "코멘트 남기기", "eng": "Enter comment" },
    "comment_submit2": { "kor": "코멘트를 작성해주세요.", "eng": "Please enter comment" },
    "no_comment": { "kor": "등록된 코멘트가 없습니다.", "eng": "No Comments." },
    "no_character_msg": { "kor": "모험가를 선택해주세요.", "eng": "Please choose adventurer" },
    "search_open": { "kor": "검색 열기", "eng": "Open Search" },
    "search_close": { "kor": "검색 닫기", "eng": "Close Search" },
    "etc_effect": { "kor": "기타 효과", "eng": "Other effect" },
    "capture_save": { "kor": "사진저장", "eng": "Save photo" },
    "wait_time": { "kor": "대기시간", "eng": "Wait Time" },
    "amount_per_day": { "kor": "하루당 획득량", "eng": "Amount per day" },
    "close_map_info": { "kor": "맵정보 닫기", "eng": "Close Map Info" },
    "open_map_info": { "kor": "맵정보 열기", "eng": "Open Map Info" },
    "active_skill": { "kor": "액티브 스킬", "eng": "Active Skill" },
    "passive_skill": { "kor": "패시브 스킬", "eng": "Passive Skill" },
    "point": { "kor": "포인트", "eng": "Point" },
    "max": { "kor": "최대", "eng": "Max" },
    "hide_memo": { "kor": "내용 숨기기", "eng": "Hide Memo" },
    "show_memo": { "kor": "내용 보기", "eng": "Show Memo" },
    "ascend": { "kor": "승천", "eng": "Ascend" },
    "ascend_toggle": { "kor": "승천 전환", "eng": "Ascend Toggle" },
    "doctrine_select": { "kor": "교리 선택", "eng": "Select Doctrine" },
    "description_order": { "kor": "ㄱ-ㅎ 순서로 정렬되어 있습니다.", "eng": "Ordered by A-Z" },
    "description_secret": { "kor": "비밀글입니다.", "eng": "This is a secret post" },
    "secret": { "kor": "비밀글", "eng": "Secret" },
    "view_post": { "kor": "작성글 보기", "eng": "View Posts." },
    "potion_all_fill": { "kor": "전부 채우기", "eng": "Fill all" },
    "potion_all_empty": { "kor": "전부 비우기", "eng": "Empty all" },
    "how_get": { "kor": "획득처", "eng": "How Get" },
    "show": { "kor": "표시", "eng": "Show" },

    "type": { "kor": "종류", "eng": "Type" },
    "stats": { "kor": "능력치 및 정보", "eng": "Stats & Info" },
    "sell_price": { "kor": "판매 가격", "eng": "Sell Price" },
    "buy_price": { "kor": "구매 가격", "eng": "Buy Price" },
    "feed_power": { "kor": "먹이 힘", "eng": "Feed Power" },

    "stat_hp": { "kor": "HP", "eng": "HP" },
    "stat_mp": { "kor": "마나 획득", "eng": "Mana gain" },
    "stat_con": { "kor": "체질", "eng": "Constitution" },
    "stat_dex": { "kor": "민첩", "eng": "Dexterity" },
    "stat_int": { "kor": "지능", "eng": "intelligence" },
    "stat_df": { "kor": "방어력", "eng": "Defence" },
    "stat_dfm": { "kor": "마법 방어력", "eng": "Magic Defence" },
    "stat_dmg": { "kor": "공격 피해량", "eng": "Attack Dmg" },

    "stat_threat":         { "kor": "위협", "eng": "Threat" },
    "stat_counter_chance": { "kor": "반격", "eng": "Counterattack" },
    "stat_evade":          { "kor": "추가 회피율", "eng": "Bonus dodge" },
    "stat_lifesteal_rate": { "kor": "생명력 흡수", "eng": "Lifesteal" },
    "stat_crt_chance":     { "kor": "치명타 확률", "eng": "Crit chance" },
    "stat_counter_dmg":    { "kor": "보복", "eng": "Retaliation" },
    "stat_crt_rate":       { "kor": "치명타 피해", "eng": "Crit damage" },
    "stat_regen":          { "kor": "재생", "eng": "Regeneration" },
    "stat_immune_chance":  { "kor": "상태이상 면역 확률", "eng": "Status immunity" },
    "stat_dark_dmg_rate":  { "kor": "어둠 피해", "eng": "Dark. dmg" },

    "stat_dark_reduction": { "kor": "어둠 감소량", "eng": "Dark. reduction" },
    "stat_healing":        { "kor": "치유량", "eng": "Healing" },
    "stat_exp":            { "kor": "경험치", "eng": "Exp" },
    "stat_decay":          { "kor": "부패", "eng": "Decay" },

    "stat_s_health":        { "kor": "HP",   "eng": "HP" },
    "stat_s_defense":       { "kor": "방어", "eng": "Def" },
    "stat_s_agility":       { "kor": "회피", "eng": "Agi" },
    "stat_s_constitution":  { "kor": "체질", "eng": "Con" },
    "stat_s_magic_defense": { "kor": "마방", "eng": "MDef" },
    "stat_s_immunity":      { "kor": "면역", "eng": "Imm" },
    "stat_s_dexterity":     { "kor": "민첩", "eng": "Dex" },
    "stat_s_precision":     { "kor": "치확", "eng": "Pre" },
    "stat_s_darkness":      { "kor": "어둠", "eng": "Drk" },
    "stat_s_intelligence":  { "kor": "지능", "eng": "Int" },
    "stat_s_viciousness":   { "kor": "치피", "eng": "Vic" },



    // alert
    "alert_wrong_approach": { "kor": "잘못된 접근입니다.", "eng": "This is the wrong approach." },
    "alert_no_update_perm": { "kor": "수정 권한이 없습니다.", "eng": "No update permission." },
    "alert_map_select": { "kor": "맵을 선택해주세요.", "eng": "Please select map." },
    "alert_exp_per_hour": { "kor": "시간당 획득 경험치를 적어주세요.", "eng": "Please enter [EXP per hour]." },
    "alert_need_login": { "kor": "로그인이 필요합니다.", "eng": "You need login." },
    "alert_id_pw": { "kor": "아이디와 비밀번호를 모두 입력해주세요.", "eng": "Please enter ID and PW." },
    "alert_join_form": { "kor": "가입정보를 모두 입력해주세요.", "eng": "Please enter All of join form." },
    "alert_logout": { "kor": "로그아웃 하시겠습니까?", "eng": "Do you want to logout?" },
    "alert_new_version": { "kor": "현재 사이트에 새로운 업데이트가 적용되어 새로고침합니다.", "eng": "A new update is available. The page will now refresh." },
    "site_version": { "kor": "웹사이트 버전", "eng": "Site version" },
  },

}